import { useStore } from '@vromo/mobx-react/mobx-react';
import { Site } from '@vromo/models';
import Debug from '@vromo/ui/components/Debug';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { ProfilePlaceholder } from '@vromo/ui/components/ProfileImage';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { RootStore } from '../stores/RootStore';
import { qaLabelTestSites } from './../../../../common-qa-labels/sites';
import { buildDynamicLabel } from './../../../../common-qa-labels/utils';
import styles from './sites.style';

const PolicyItem = observer(({ id, siteName }: { id?: number; siteName?: string }) => {
    const { policyStore } = useStore<RootStore>('rootStore');

    if (!id)
        return (
            <span className={styles.warning}>
                <FontAwesome icon="exclamation-triangle" className={styles.warningIcon} />
                None - Manual Dispatch
            </span>
        );

    const policyName = policyStore.withId(id)?.name || siteName;

    return <>{policyName}</>;
});

interface SiteRowProps {
    onClick: (s: Site) => void;
    site: Site;
}

const SiteRow = observer<SiteRowProps>(({ onClick, site }) => {
    const { campaignStore, blueprintStore, groupStore } = useStore<RootStore>('rootStore');

    const group = site.group ? groupStore.withId(site.group)?.name : null;
    const blueprint = site.blueprint?.id ? blueprintStore.withId(site.blueprint.id)?.name : null;
    const campaignName = site.campaign?.id
        ? campaignStore.withId(site.campaign.id)?.name ?? site.campaign?.name
        : null;

    return (
        <>
            <tr
                className={styles.rowContainer}
                onClick={() => onClick(site)}
                data-testid={buildDynamicLabel(qaLabelTestSites.tableRow, site.id)}>
                <td className={styles.profile}>
                    <ProfilePlaceholder initials={site.contact!.name![0]!} id={site.id!} />
                </td>
                <td>{site.contact?.name}</td>
                <td>{site.contact?.address}</td>
                <td>{group}</td>
                <td>
                    <PolicyItem
                        id={site.policy?.id || undefined}
                        siteName={site.policy?.name || ''}
                    />
                </td>
                <td>{campaignName}</td>
                <Debug>
                    <td>{blueprint}</td>
                </Debug>
            </tr>
        </>
    );
});

export default SiteRow;
